<template>
  <div class="step-questions-last">
    <h2 class="text-[18px] text-primary mb-[27px]">
      {{ question.questionText }}
    </h2>
    <div class="question-description" v-if="question.questionDescription" v-html="question.questionDescription"></div>
    <ul v-if="hasInfoPoints">
      <li v-for="(point, idx) in question.infoPoints" :key="idx" v-html="point"></li>
    </ul>

    <button
      v-on:click="$emit('submit')"
      class="submit-and-continue"
      type="button"
      data-amplitude-id="proceed-to-checkout"
    >
      {{ isDe ? "Ich stimme zu" : "Agree and continue" }}
      <amp-img
        noloading="noloading"
        class="share-icons"
        :src="buttonArrowSrc"
        alt=""
        :width="buttonArrowWidth"
        :height="buttonArrowHeight"
      />
    </button>

    <div class="comment" v-if="showComment">
      {{ comment }}
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import _ from "lodash";

import { YesNoQuestion } from "../../types";

export default Vue.extend({
  name: "AgreementQuestion",
  props: {
    theme: {
      type: String,
      required: true,
    },
    acceptTerms: {
      type: Boolean,
      required: true,
    },
    hostNameWithSchema: {
      type: String,
      required: true,
    },
    showRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    question: {
      type: Object as PropType<YesNoQuestion>,
      required: true,
    },
    showComment: {
      type: Boolean,
      required: false,
      default: true,
    },
    isCheckInConsultation: {
      type: Boolean,
      required: true,
    },
  },
  created() {
    this.$emit("validation", this.question.id, true);
  },
  computed: {
    hasInfoPoints(): boolean {
      return !_.isEmpty(this.question.infoPoints);
    },
    buttonArrowSrc(): string {
      // `black_right_arrow.svg` is the same as `@/ComponentLibrary/assets/arrow_right.svg` and is for levity theme
      return this.theme === "levity"
        ? "/resources/img/icons/black_right_arrow.svg"
        : "/resources/img/icons/white_right_arrow.svg";
    },
    // Remember to apply any changes here to StepConsultation.vue as well
    buttonArrowWidth(): number {
      return this.theme === "levity" ? 24 : 26;
    },
    // Remember to apply any changes here to StepConsultation.vue as well
    buttonArrowHeight(): number {
      return this.theme === "levity" ? 24 : 16;
    },
    isDe(): boolean {
      return process.env.REGION === "de";
    },
    doctorWord(): string {
      return process.env.REGION == "uk" ? "pharmacist" : "physician";
    },
    comment(): string {
      if (this.isDe) {
        return "Das Ärzteteam schaut sich Ihren Fragebogen an, nachdem Sie Ihr Medikament bestellt haben. Bei eventuellen Rückfragen wendet sich das Team an Sie.";
      }
      if (this.isCheckInConsultation) {
        return `A ${this.doctorWord} will review your answers after you complete your check in`;
      }
      return `A ${this.doctorWord} will review your answers after you complete checkout`;
    },
  },
});
</script>
